import Price from "./Price";

export * from "./Price";

export default Price;
